import BaseComponent from 'scripts/BaseComponent.js';

export default class BlogArticleCard extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      link: '.js-link',
      container: '.js-container',
    };

    this.dom = {
      $component: component,
      $containers: this.$getAll(this.refs.container),
    };

    this.state = {};

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();
    this.setClickWithElement(dom.$containers, this.clickHandler);
  }

  clickHandler(element) {
    const link = element.querySelector(this.refs.link);
    const target = link.getAttribute('target');

    if (target === '_blank') {
      window.open(link.href, '_blank');
    } else {
      window.location.href = link.href;
    }
  }
}
